import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 0;
    padding: 0;
  `}
`;
export const LeftWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: 0;
    position: fixed;
    height: 100%;
    width: 40%;
    top: 0;
    background-color: #012d5c;

    @media only screen and (max-width:480px) {
    /* display: none; */
    width: 100%;
    height: 15%;
    
    img{
      width: 30%;
      height: 100%;
    }
  }
}

    div {
      height: 2.4rem;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;

      background-color: ${theme.colors.blueThird};
    }
    img {
      height: 100%;
      width: 75%;
      margin: 10px 0 0 12.5%
    }

  `}
`;
export const RightWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: 10%;
    margin-left: 50%;
    width: 40%;
  `}
  /* Navbar right form fields */
  @media only screen and (max-width: 480px) {
    display: contents;
  }
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.grayFour};
    font-size: ${theme.font.sizes.large};
    line-height: 1.2;
    font-weight: bold;
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    width: 70%;
    height: 100%;
    padding-bottom: 1rem;
    border-bottom: 0.3rem solid ${theme.colors.lineBlue};
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: auto;
    margin-bottom: 5rem;
    /* header */
    @media only screen and (max-width: 480px) {
      margin-top: 105px;
    }

    ${Description} {
      font-style: italic;
      color: ${theme.colors.yellow};
    }
  `}
`;

export const TitleBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    ${Description} {
      color: ${theme.colors.grayFour};
      font-size: 30px;
      font-style: normal;
      /* descricao */
      @media (max-width: 1663px) {
        font-size: 24px;
        margin-top: 20px;
      }
    }
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: 30px;
    color: ${theme.colors.grayFour};
  `}
  /* titulo and descricao */
  @media (max-width: 1663px) {
    margin-top: 30px;
  }
`;

export const Content = styled.div`
  .div-form {
    width: 100%;
    margin: auto;
  }
  form {
    width: 100%;
    margin: auto;
  }
`;

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    margin: auto;
    margin-top: 4rem;
    width: 70%;

    button {
      margin-left: 32%;
      margin-top: 5rem;
      font-size: ${theme.font.sizes.xlarge};
    }
    /* button */
    @media (max-width: 1663px) {
      margin-top: 50px;

      button {
        margin: auto;
        display: block;
      }
    }
  `}
`;
export const ForgotPassWord = styled.div`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    text-align: center;
    color: ${theme.colors.lineBlue};
    margin-top: 5rem;

    a {
      color: #00a2e0;
      text-decoration: none;
    }

    a:hover {
      color: #0060b6;
      text-decoration: none;
      cursor: pointer;
    }

    @media (max-width: 1663px) {
      margin-bottom: 15px;
    }
  `}
`;

export const SubTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.grayFour};
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    font-family: Roboto;
    font-weight: 500;

    &::after {
      content: "";
      display: block;
      width: 90%;
      height: 0.3rem;
      border-bottom: 2px solid #ddd;

      margin-top: 1.6rem;
    }
  `}
`;
export const SkeletonInput = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.grayFour};
    width: 100%;
    margin-top: 7rem;
    margin-left: 11rem;
  `}
`;
